﻿import { createContext } from 'react';

const FileUploadContext = createContext({});

export default FileUploadContext;
